/**
 * Distance from the viewport top that the fixed menu occupies. Sections carry
 * the same value as `scroll-mt-24` in `SectionRenderer` - keep the two in step.
 */
export const SECTION_SCROLL_OFFSET = 96;

/** Fractional rects after a smooth scroll must still count as arrived. */
export const ACTIVE_SECTION_TOLERANCE = 24;
